import http from '@root/utils/axios/admin';

let state = {
    DocumentsList: [],
    Document: {
        data: {},
        error: {}
    },
}

let actions = {

    fetchDocumentsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/documents', { params: filter }).then((response) => {
                commit('setDocuments', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteDocument({ commit }, id) {
        return http.delete('/subscriber/documents/' + id);
    },

    fetchDocument({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/documents/' + id).then((response) => {
                commit('setDocument', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateDocument({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/documents', data).then((response) => {
                commit('setDocument', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDocumentError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateDocument({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/documents/' + data.id, data).then((response) => {
                commit('setDocument', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDocumentError', error.response.data);
                }
                reject(error.response);
            })
        });
    },


}


let mutations = {
    setDocuments(state, data) {
        state.DocumentsList = data;
    },
    setDocument(state, data) {
        state.Document.data = data;
    },
    setDocumentError(state, error) {

        state.Document.error = error.errors;
    },
    cleanDocumentError(state, error) {
        state.Document.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}